import React, { memo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Button,
} from '@mui/material';
import { ChapterFormData } from './types';

interface ChapterDialogProps {
  open: boolean;
  isEdit: boolean;
  formData: ChapterFormData;
  onClose: () => void;
  onFormChange: (data: ChapterFormData) => void;
  onSubmit: () => void;
}

const ChapterDialog = memo<ChapterDialogProps>(({
  open,
  isEdit,
  formData,
  onClose,
  onFormChange,
  onSubmit,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEdit ? 'Edit Chapter' : 'Create Chapter'}</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            fullWidth
            label="Chapter Name *"
            value={formData.name}
            onChange={(e) => onFormChange({ ...formData, name: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Description"
            multiline
            rows={3}
            value={formData.description}
            onChange={(e) =>
              onFormChange({ ...formData, description: e.target.value })
            }
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            type="number"
            label="Order"
            value={formData.order}
            onChange={(e) =>
              onFormChange({ ...formData, order: parseInt(e.target.value) })
            }
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSubmit}>
          {isEdit ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

ChapterDialog.displayName = 'ChapterDialog';

export default ChapterDialog;
